import axios from 'axios';
import { GetAuthToken } from './AuthStatus';

export async function RemainingWstUsageStatus() {
  const token = GetAuthToken();
    try {

      var config = {
        method: 'get',
        url: `${process.env.REACT_APP_BACKEND_SERVICE}/backend-service/v1/usage/website-speed-tool`,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      return axios(config)
        .then(function (response) {
          return response.data;
        }).catch(function (error) {
          console.log(error);
        });

    } catch (error) {
      return error.response;
    }

}
